module.exports = __webpack_public_path__ + "img/koniec@mob.9188b628.webp";